export const ACTION = {
    VERIFY_PAN_FOLIO: 'VERIFY_PAN_FOLIO',
    VERIFY_OTP: 'VERIFY_OTP',
    TOKEN: 'TOKEN',
    ACCOUNT_STATEMENT: 'ACCOUNT_STATEMENT',
    ACCOUNT_META: 'ACCOUNT_META'
}